<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="box-shadow: none; border: 1px solid #ccc">
    <ng-container matColumnDef="Item_name">
        <th mat-header-cell *matHeaderCellDef>Item Name</th>
        <td mat-cell *matCellDef="let element">
            {{ element.Item_name }}
        </td>
    </ng-container>

    <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
            {{ element.Status }}
        </td>
    </ng-container>

    <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef>Comments</th>
        <td mat-cell *matCellDef="let element">
            {{ element.comments }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
